import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("helix_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (error) => {
    // Normalize FastAPI error detail to a string so components can safely render it as a toast.
    // A 422 returns `detail` as an array of objects, which would otherwise crash React / show [object Object].
    const rd = error.response?.data;
    if (rd && rd.detail != null && typeof rd.detail !== "string") {
      const d = rd.detail;
      rd.detail = Array.isArray(d)
        ? d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ")
        : (typeof d.msg === "string" ? d.msg : JSON.stringify(d));
    }
    const status = error.response?.status;
    const detail = error.response?.data?.detail || "";
    const hasToken = localStorage.getItem("helix_token");
    if (status === 401 && hasToken && typeof detail === "string" && (detail.toLowerCase().includes("session") || detail.toLowerCase().includes("expired"))) {
      localStorage.removeItem("helix_token");
      if (!window.location.pathname.startsWith("/login")) {
        // Videowall viewer: jump straight back into Microsoft sign-in so the wall recovers unattended.
        const wall = localStorage.getItem("helix_wall") === "1";
        window.location.href = wall ? "/login?expired=1&auto=1" : "/login?expired=1";
      }
    }
    // Logged-out / teardown state: the token is already cleared, so 401s here come from
    // straggler requests fired by unmounting authenticated pages. Swallow them (return a
    // non-resolving promise) so they never surface as uncaught runtime errors.
    if (status === 401 && !hasToken) {
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default client;
